import { render } from "./Weight.vue?vue&type=template&id=71a9262e&scoped=true"
import script from "./Weight.vue?vue&type=script&lang=js"
export * from "./Weight.vue?vue&type=script&lang=js"

import "./Weight.vue?vue&type=style&index=0&id=71a9262e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a9262e"]])

export default __exports__